module.exports = __webpack_public_path__ + "img/unity.a60fbb19.svg";